import { FC, ReactNode, useMemo } from "react";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { IconButton } from "@mui/material";
import { Button } from "../Button";
import {
  StyledDrawer,
  StyledDrawerContent,
  StyledDrawerHeader,
} from "styles/components/drawer";

interface DrawerProps {
  width?: string;
  open?: boolean;
  children?: ReactNode;
  withBackBtn?: boolean;
  dataTestId?: string;
  overflow?: "hidden" | "visible" | "auto";

  onClose?: () => void;
  onBack?: () => void;
}

const Drawer: FC<DrawerProps> = ({
  width,
  open,
  dataTestId,
  children,
  withBackBtn,
  overflow,
  onClose,
  onBack,
}) => {
  const renderedBackButton = useMemo(
    () =>
      withBackBtn && (
        <Button
          variant="text"
          startIcon={<ChevronLeftOutlinedIcon />}
          onClick={onBack}
          dataTestId={dataTestId && `${dataTestId}-back`}
        >
          Go Back
        </Button>
      ),
    [dataTestId, onBack, withBackBtn]
  );

  return (
    <StyledDrawer
      open={open}
      onClose={onClose}
      anchor="right"
      width={width}
      data-testid={dataTestId}
    >
      <StyledDrawerHeader withBackBtn={withBackBtn}>
        {renderedBackButton}
        <IconButton
          className="drawer-close"
          data-testid={dataTestId && `${dataTestId}-close`}
          onClick={onClose}
        >
          <CloseOutlinedIcon />
        </IconButton>
      </StyledDrawerHeader>
      <StyledDrawerContent
        data-testid={dataTestId && `${dataTestId}-content`}
        overflow={overflow}
      >
        {children}
      </StyledDrawerContent>
    </StyledDrawer>
  );
};

export default Drawer;
